module.exports = __webpack_public_path__ + "static/img/img-home-jzg-06.2aaad51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-jzg-06.png
// module id = 2qCp
// module chunks = 1